import { Mode } from '../models/commons.models'

// http://application:3000/
const ApplicationConfig = {
  mode: Mode.app,
  appVersion: 1.04,
}
export default ApplicationConfig
